export { default as withAdditionalProps } from '@components/hoc/withAdditionalProps/withAdditionalProps';



// WEBPACK FOOTER //
// ./src/components/hoc/withAdditionalProps/index.ts